// tslint:disable:only-arrow-functions
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createHorizontalScrollablePanelBoughtThisSeason } from '../common';

export const horizontalScrollablePanelBoughtThisSeasonLandingPage =
  mergeMultipleConfigs(createHorizontalScrollablePanelBoughtThisSeason(), [
    {
      id: 'root',
      data: {
        brandOrganisation: {
          values: [
            {
              provider: 'GlobalStoreProviderService',
              property: {
                path: 'session.siteId',
              },
            },
            {
              provider: 'GlobalStoreProviderService',
              property: {
                path: 'accounts.activeAccount.sites',
              },
            },
          ],
          transform: function ([siteId, sites]: [
            string,
            { siteId: string; brandId: string }[],
          ]) {
            return sites.find((site) => site.siteId === siteId);
          }.toString(),
        },
        brandId: {
          provider: 'self',
          property: 'brandOrganisation',
          transform: function (site: { siteId: string; brandId: string }) {
            return site.brandId;
          }.toString(),
        },
        panelName: 'BoughtThisSeasonPanel',
        panelStyleConstants: {
          page: 'pb',
          location: 'sp',
          type: 'hr',
          provider: 'neo',
          cssVariant: '001',
        },
      },
    },
    {
      id: 'scrollable-panel-container',
      contentTypeId: 'dynamic-collections-renderer',
      styles: {
        style: {
          'background-color': {
            provider: 'id:root',
            property: 'backgroundColor',
          },
          'border-radius': 'var(--border-radius-lg, .25rem)',
          'box-shadow': '0px 0px 8px 1px rgb(199 199 199)',
        },
      },
    },
  ]);
